export class ExternalMAMUpdateItemMetadataRequest {
  constructor(
    public id: string,
    public videoIds: Array<string> = [],
  ) {}
}
